import React from 'react';

import AddMemberToProject from '@features/project-management-tools/components/AddMemberToProject';

import { BackButton } from '@/components/buttons/BackButton';

const ProjectDetailsTopbar = ({ projectDetails, children }) => {
	return (
		<div className="top-header collection-topbar">
			{/* Filter Contanier top */}
			<div className="container-fluid pt-3 pl-0">
				<div className="row">
					<div className="col-md-8">
						<div className="collection-overview d-flex align-items-center">
							<BackButton />
							<h1 className="semibold-14 m-0 ml-2">{projectDetails?.name}</h1>
							{projectDetails?.brandResponse?.name && (
								<div className="collection-status pl-3 mr-2">
									<span className="brand-common-design">
										{projectDetails?.brandResponse?.name}
									</span>
								</div>
							)}
						</div>
					</div>
					<div className="col-md-4">
						<AddMemberToProject projectId={projectDetails?.id || null} />
					</div>
				</div>
			</div>
			{children}
		</div>
	);
};

export default ProjectDetailsTopbar;
